import React, { Component } from 'react';
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';

import { CONSTANCIA } from './Styles/Styles';
import logo from "../../assets/img/logo_menu_black.png";
import firma from "../../assets/img/firma.png";

class SolvenciaAdmin extends Component {
    state = {  }
    render() {
        const styles = StyleSheet.create(CONSTANCIA[0]);
        let { datos, autoridad } = this.props;

        let fecha = () => {
            let fehaEnt = datos.fecha;
            let fechaPartes = fehaEnt.split("/")
            let meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre' ]
            return `${fechaPartes[0]} días del mes de ${meses[parseInt(fechaPartes[1]) - 1]} de ${fechaPartes[2]}`
        }

        return (
            <PDFViewer style={styles.section}>
                <Document title="Solvencia Administrativa">
                    <Page size="letter" style={styles.body}>
                        <View>
                            <Image
                                style={styles.logo}
                                src={logo}
                            />
                            <Text style={[styles.encabezado, {marginTop: 10}]}>REPÚBLICA BOLIVARIANA DE VENEZUELA</Text>
                            <Text style={styles.encabezado}>MINISTERIO  DEL  PODER  POPULAR  PARA  LA  EDUCACIÓN  UNIVERSITARIA</Text>
                            <Text style={styles.encabezado2}>INSTITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES</Text>
                            <Text style={styles.encabezado3}>M.E. Nº 130 G.O. Nº 36.719  9 JUNIO 1.999</Text>
                            <Text style={[styles.encabezado3, {marginTop: -5}]}>RIF.J-30583313-3</Text>

                            <Text style={[styles.encabezado4, {marginTop: 40}]}>SOLVENCIA ADMINISTRATIVA</Text>

                            <Text style={[styles.parrafo, {marginTop: 20, textAlign: 'justify'}]}>
                                Quien suscribe, {`${autoridad.aut_name} ${autoridad.aut_ape}`}, titular de la Cédula de Identidad {autoridad.cedula}, en mi carácter de
                            </Text>
                            <Text style={[styles.parrafo, {marginTop: 10, textAlign: 'justify'}]}>
                                <Text style={{fontSize: 12}}>ADMINSTRADOR(A)</Text> del Instituto Universitario De Diseño Las Mercedes, hago constar  que
                            </Text>
                            <Text style={[styles.nombre, {marginTop: 10}]}>
                                {datos.estudiante}
                            </Text>
                            <Text style={[styles.parrafo, {marginTop: 10}]}>
                                Titular de la Cédula de Identidad {datos.cedula}, se encuentra solvente del pago de sus aranceles para la fecha.
                            </Text>

                            <Text style={[styles.parrafo, {marginTop: 10}]}>
                                Este documente se expide a solicitud de la parte interesada,
                                para todo fin útil y de plena fe, en Caracas, a los {fecha()}.
                            </Text>

                            <Image
                                style={styles.firmaL}
                                src={firma}
                            />

                            <Text style={[styles.firma, {marginTop: -20}]}> {`${autoridad.aut_name} ${autoridad.aut_ape}`} </Text>
                            <Text style={[styles.firma, {marginTop: -5}]}> ADMINISTRADOR(A) </Text>

                            <View style={[styles.footer3]}>
                                <View style={[styles.row]}>
                                    <View style={[styles.col9]}>
                                        <Text style={[styles.encabezado, {fontSize: 6, textAlign: "center"}]}>
                                            Esta planilla debe ser impresa en Papel Bond Blanco tamaño Carta | Para autenticar esta constancia vaya al enlace: https://iudlm.com/validar?code={this.props.token}. También puede escanear el código qr de la derecha.
                                        </Text>
                                        <Text style={[styles.linea2]}></Text>
                                        <Text style={[styles.encabezado, {fontSize: 7}]}>
                                            Av. Río de Janeiro con Calle Roraima, quinta Los Abuelos, N° 78, Urbanización Chuao, 
                                            C.P.1061  Edo Miranda - Caracas - Venezuela
                                        </Text>
                                        <Text style={[styles.encabezado, {marginTop: -5, fontSize: 7}]}>
                                            Telefax: +58 212 9930983 | 9939139 | 9910710.
                                        </Text>
                                    </View>
                                    <View style={[styles.col10]}>
                                        <Image
                                            style={[styles.logoQr, {left:20}]}
                                            src={this.props.QrCode}
                                        />  
                                    </View>
                                </View>
                            </View>
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        );
    }
}
 
export default SolvenciaAdmin;


// WEBPACK FOOTER //
// ./src/components/Reportes/SolvenciaAdmin.jsx